
import { Button } from "@/components/ui/button";
import { Mail, Check } from "lucide-react";

interface EmailVerificationPromptProps {
  onResendEmail: () => void;
  email: string;
}

export function EmailVerificationPrompt({ onResendEmail, email }: EmailVerificationPromptProps) {
  return (
    <div className="flex flex-col items-center space-y-4 text-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-purple-100">
        <Mail className="h-10 w-10 text-purple-600" />
      </div>
      
      <h3 className="text-xl font-bold">Verify your email address</h3>
      
      <p className="text-gray-600">
        We've sent a verification link to{" "}
        <span className="font-medium text-gray-900">{email}</span>
      </p>
      
      <p className="text-sm text-gray-500">
        Please check your inbox and click the verification link to complete your registration.
        If you don't see the email, check your spam folder.
      </p>
      
      <div className="pt-4">
        <Button onClick={onResendEmail} variant="outline" className="w-full">
          Resend verification email
        </Button>
      </div>

      <div className="flex w-full items-center justify-between rounded-lg bg-wabisabi-offwhite p-3 text-sm">
        <div className="flex items-center space-x-2">
          <Check className="h-5 w-5 text-green-500" />
          <span className="text-gray-800">Secure account verification</span>
        </div>
        <span className="text-xs text-gray-500">SSL Encrypted</span>
      </div>
    </div>
  );
}
